// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"279":"56305ab0d48d9b0b","350":"0a08c0a5b7a22559","967":"fa91397c302ae690"}[chunkId] + ".js";
};